var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import useService from "../../Hooks/useService";
import MessageService from "../../../Services/Message.service";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import MessageThread from "../../Container/Message/MessageThread";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
import FAIcon from "../../UI/FAIcon/FAIcon";
import NoteModal from "../../Presentational/Note/NoteModal";
import MessageInlineReplyForm from "../../Container/Message/MessageInlineReplyForm";
import MessageTemplateService from "../../../Services/MessageTemplate.service";
import AttachmentService from "../../../Services/Attachment.service";
import useAttachments from "../../Hooks/useAttachments";
import { getMessageInboxPath, getMessageSentPath, } from "./MessageRoutes/MessageRoutes";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import MessageThreadService from "../../../Services/MessageThread.service";
import { SendButton } from "../../UI/StandardButtons/StandardButtons";
import { UPLOAD_CONFIG, getAcceptedFileTypesDisplay, } from "../../../Config/upload.config";
const MessageDetailView = (props) => {
    const params = useParams();
    const threadId = params === null || params === void 0 ? void 0 : params.id;
    const history = useHistory();
    const location = useLocation();
    const [canLogMessages, setCanLogMessages] = useState(false);
    useEffect(() => {
        MessageService.canILogMessages().then(setCanLogMessages);
    }, []);
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
    const [selectedThread, setSelectedThread] = useState(null);
    const [isReply, setIsReply] = useState(false);
    const [noteText, setNoteText] = useState("");
    const [messagesState, loadMessages] = useService(MessageService.getMessageThread);
    const { attachmentButton: attachButton, attachmentsComponent: showAttachments, warningText: attachmentWarningText, resetAttachments: refreshAttachments, attachments, draftId, onAttachmentRemove, } = useAttachments();
    const _a = useForm(), { handleSubmit } = _a, formProps = __rest(_a, ["handleSubmit"]);
    const { setIsMobileFullScreen } = props;
    useEffect(() => {
        if (threadId != null) {
            loadMessages(threadId);
            setIsReply(false);
            refreshAttachments();
            setIsMobileFullScreen(true);
        }
    }, [loadMessages, threadId, refreshAttachments, setIsMobileFullScreen]);
    const [personalizationMenuState, loadPersonalizationMenus] = useService(MessageTemplateService.getPersonalizationMenus);
    useEffect(() => {
        loadPersonalizationMenus();
    }, [loadPersonalizationMenus]);
    const [replyState, reply, replyActions] = useService(MessageThreadService.advisorReplyToThread);
    const inlineAttachments = formProps.watch("inlineAttachments");
    const resetState = () => {
        setIsReply(false);
        refreshAttachments();
        replyActions.clear();
    };
    const [removeDirectoryState, removeDirectory] = useService(AttachmentService.removeDirectory);
    const submit = (form) => __awaiter(void 0, void 0, void 0, function* () {
        if (!messagesState.data) {
            throw new Error("Thread not loaded, wait a moment");
        }
        const threads = messagesState.data;
        const lastThread = threads[threads.length - 1];
        if (threadId) {
            yield reply({
                body: lastThread.isSms ? form.smsBody : form.body,
                saveMessageAsNote: form.noteFromMessage,
                noteTypeIds: form.noteFromMessage
                    ? form.selectedNoteTypes.map((noteType) => noteType.id)
                    : [],
                attachmentIds: attachments.map((attachment) => attachment.attachmentId),
                threadId,
                logMessage: form.logMessage,
                inlineAttachments: form.inlineAttachments || false,
            });
        }
        else {
            throw new Error("No thread id");
        }
        // Remove Temp Directory
        removeDirectory(draftId);
        resetState();
        loadMessages(threadId);
    });
    const submitButtonRef = React.useRef(null);
    const renderReplyButtons = () => {
        if (messagesState.data && messagesState.data.length !== 0) {
            if (isReply) {
                return (_jsxs(_Fragment, { children: [_jsx(SecondaryNavButton, { icon: "paper-plane", label: "Send", title: "Send this message", disabled: replyState.isLoading, isLoading: replyState.isLoading, onClick: () => { var _a; return (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }), !messagesState.data[messagesState.data.length - 1].isSms &&
                            attachButton, _jsx(SecondaryNavButton, { icon: "times", type: "button", label: "Cancel", title: "Cancel Reply", onClick: resetState })] }));
            }
            return (_jsx(SecondaryNavButton, { icon: "reply", label: "Reply", type: "button", title: "Reply to Message", onClick: () => setIsReply(true) }));
        }
        return null;
    };
    const nav = (_jsxs("div", { className: "d-flex align-items-center justify-content-between flex-grow-1", children: [_jsx("div", { className: "d-flex", children: renderReplyButtons() }), _jsx("button", { type: "button", className: "d-none d-md-block btn btn-link text-dark", onClick: () => props.setIsFullScreen((fs) => !fs), title: props.isFullScreen ? "Exit Fullscreen" : " Enter Fullscreen", children: _jsx(FAIcon, { icon: props.isFullScreen ? "times" : "expand", srText: props.isFullScreen ? "Exit Fullscreen" : " Enter Fullscreen" }) }), _jsx("button", { type: "button", className: "d-block d-md-none btn btn-link text-dark", onClick: () => {
                    props.setIsMobileFullScreen(false);
                    if (location === null || location === void 0 ? void 0 : location.pathname.includes("inbox")) {
                        history.push(getMessageInboxPath());
                    }
                    else {
                        history.push(getMessageSentPath());
                    }
                }, title: "Exit Fullscreen", children: _jsx(FAIcon, { icon: "times", srText: "Exit Fullscreen" }) })] }));
    const getAffiliationId = () => {
        if (!selectedThread) {
            return null;
        }
        // @ts-expect-error - TS2339 - Property 'myMessage' does not exist on type 'never'.
        return selectedThread.myMessage
            ? // @ts-expect-error - TS2339 - Property 'receiverId' does not exist on type 'never'.
                selectedThread.receiverId
            : // @ts-expect-error - TS2339 - Property 'senderId' does not exist on type 'never'.
                selectedThread.senderId;
    };
    return (_jsxs(_Fragment, { children: [_jsx("form", { onSubmit: handleSubmit(submit), children: _jsx(SecondaryNavLayout, { nav: nav, children: _jsx("div", { className: "container-fluid pt-3 pb-5 fullMinHeightMinusSecondaryNav bg-light", children: _jsx(ServiceResult, { state: messagesState, children: (messages) => {
                                var _a, _b, _c;
                                return (_jsxs(_Fragment, { children: [_jsx("div", { className: "border-bottom", children: _jsx("h1", { 
                                                /* eslint-disable-next-line react/no-danger */
                                                dangerouslySetInnerHTML: {
                                                    __html: ((_a = messages[messages.length - 1]) === null || _a === void 0 ? void 0 : _a.sanitizedSubject) || "",
                                                } }) }), isReply && (_jsxs("div", { className: "mt-3", children: [_jsx(MessageInlineReplyForm, Object.assign({ isEmail: !((_b = messages[messages.length - 1]) === null || _b === void 0 ? void 0 : _b.isSms), threadId: threadId }, formProps, { personalizationMenus: personalizationMenuState })), _jsx("div", { className: "d-flex flex-wrap", children: showAttachments }), !!attachments.length &&
                                                    !inlineAttachments &&
                                                    attachmentWarningText, replyState.hasError && (_jsx(AlertError, { message: "There was an error sending your message", detail: replyState.errorMessage })), _jsxs("div", { className: `d-flex justify-content-between align-items-center ${attachments.length !== 0 ? "mt-3" : ""}`, children: [_jsxs("div", { className: "d-flex", children: [_jsx(SendButton, { type: "submit", isLoading: replyState.isLoading, ref: submitButtonRef }), _jsxs("button", { className: "btn btn-outline-secondary ml-2", type: "button", onClick: resetState, children: [_jsx(FAIcon, { icon: "times", srText: "Cancel Reply", addMarginRight: true }), "Cancel"] })] }), !((_c = messages[messages.length - 1]) === null || _c === void 0 ? void 0 : _c.isSms) && (_jsx("div", { children: _jsx(FAIcon, { size: "lg", icon: "info-circle", title: `Accepted file types: ${getAcceptedFileTypesDisplay()}.\nMaximum ${UPLOAD_CONFIG.MAX_FILES} files each upload, total attachment size must be under 30MB.` }) }))] }), _jsx("hr", {})] })), messages.map((thread) => (_jsx(MessageThread, { thread: thread, hasPermissionForTermSuccessScore: props.hasPermissionForTermSuccessScore, hasPermissionForCourseSuccessScore: props.hasPermissionForCourseSuccessScore, onAddNote: () => {
                                                setNoteText(thread.message);
                                                setIsNoteModalOpen(true);
                                                // @ts-expect-error - TS2345 - Argument of type 'Message' is not assignable to parameter of type 'SetStateAction<null>'.
                                                setSelectedThread(thread);
                                            }, onLogMessage: () => {
                                                MessageService.log(thread.messageId).then(() => {
                                                    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                                                    loadMessages(threadId);
                                                });
                                            }, hasPermissionToLogMessage: canLogMessages }, thread.messageId)))] }));
                            } }) }) }) }), _jsx(NoteModal, { createFromMessage: true, 
                // @ts-expect-error - TS2339 - Property 'messageId' does not exist on type 'never'.
                sourceId: selectedThread ? selectedThread.messageId : null, appendToBody: true, isOpen: isNoteModalOpen && selectedThread, onModalClosed: () => {
                    setIsNoteModalOpen(false);
                    setSelectedThread(null);
                }, studentAffiliationId: getAffiliationId(), onSave: () => {
                    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                    loadMessages(threadId);
                }, size: "md", 
                // @ts-expect-error - TS2740 - Type '{ text: string; }' is missing the following properties from type 'Note': id, author, person, createdDate, and 7 more.
                note: { text: noteText } })] }));
};
export default MessageDetailView;
